import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {SegmentationService} from '../../../../services/segmentation/segmentation.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';


@Component({
  selector: 'app-segmentation-attribute',
  templateUrl: './segmentation-attribute.component.html',
  styleUrls: ['./segmentation-attribute.component.css']
})
export class SegmentationAttributeComponent extends BaseComponent implements OnInit{
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  totalCount: number = 0;
  attrList = [];
  ord = 'desc';
  colname = "createdon";
  limit = 10;
  offset = 0;
  page = 1;

  constructor(private segmentService: SegmentationService) {
    super();
  }
  ngOnInit() {
    this.ngxSpinnerService.show();
    this.getList();
  }

  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.offset = 0;
          this.page = 1;
          this.ngxSpinnerService.show();
        }),
        switchMap(data => this.segmentService.getSegementAttributeList(this.limit, this.offset, this.colname, this.ord, this.searchText.nativeElement.value))
      ).subscribe(data => {
        if (data.status) {
          if (data.data.rows == null) { this.attrList = [] }
          else { this.attrList = data.data.rows }
          this.totalCount = data.data.total;
        } else {
          this.attrList = [];
          this.totalCount = 0;
        }
        this.ngxSpinnerService.hide();
      });
  }

  //  ###############  Get Attributes Group List  #######  //

  getList(){
    let searchTerm = this.searchText.nativeElement.value;
    this.offset = (this.page - 1) * this.limit;
    this.ngxSpinnerService.show();
    this.segmentService.getSegementAttributeList(this.limit, this.offset, this.colname, this.ord, searchTerm).subscribe(data => {
      if (data.status) {
        if (data.data.rows == null) { this.attrList = [] }
        else { this.attrList = data.data.rows }
        this.totalCount = data.data.total;
      } else {
        this.attrList = [];
        this.totalCount = 0;
      }
      this.ngxSpinnerService.hide();
    }, error => {
      this.toastrService.error(error);
      this.ngxSpinnerService.hide();
    });
  }

  //   ##############  Set Order ########################  //

  sorting(col) {
    this.colname = col
    if (this.ord == 'asc') {
      this.ord = 'desc'
    } else {
      this.ord = 'asc'
    }
    this.getList()
  }

  //   ##############  Edit Attribute ##################  //

  editAttribute(id){
    let URL = '/corporate/newsegmentationattribute' + '?attrId=' + id;

    this.router.navigate(['/corporate/newsegmentationattribute'], { queryParams :{attrId:id} });

  }

  //  ###############  Update Segmentation Attribute Status  #######  //

  updateAttributeStatus(event, obj) {
    event.preventDefault();
    let stat = 'InActive';
    if (!obj.isactive) {
      stat = 'Active';
    }

    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To ' + stat + '?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          const userObject = {
            id: obj.field_id,
            status: !obj.isactive
          };
          // console.log(userObject)
          this.ngxSpinnerService.show();
          this.segmentService.updateSegmentationAttributeStatus(userObject).subscribe(data => {
              if (data.status) {
                this.toastrService.success('Status Changed Successfully');
                this.getList();
              } else {
                this.toastrService.error(data.message);
                this.ngxSpinnerService.hide();
              }
            },
            error => this.ngxSpinnerService.hide());
        }
      }).catch(() => {
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    });
  }

  deleteAttribute(id){
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to delete the Attribute'  + '?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          // console.log(userObject)
          this.ngxSpinnerService.show();
          this.segmentService.deleteSegmentationAttribute(id).subscribe(data => {
              if (data.status) {
                this.toastrService.success('Attribute Deleted Successfully');
                this.getList();
              } else {
                this.toastrService.error(data.message);
                this.ngxSpinnerService.hide();
              }
            },
            error => this.ngxSpinnerService.hide());
        }
      }).catch(() => {
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    });
  }
}
